<template>
  <div class="template-card--wrap">
    <div class="template-card">
      <bh-text-input
        label="Name"
        v-model="user.name"
        v-if="user.name"
        showConfirmEdit
        inputEditingBackgroundClass="bhWhite"
        @input="inputUpdate('name', $event)"
      />
      <bh-text-input
        label="Description"
        v-model="user.description"
        v-if="user.description"
        showConfirmEdit
        inputEditingBackgroundClass="bhWhite"
        @input="inputUpdate('description', $event)"
      />
      <dialog-checkbox
        name="isProcedureDateRelated"
        readonly
        :value="user.isProcedureDateRelated"
        :option="{
          label: 'Depends on Participants target date',
          value: user.isProcedureDateRelated,
        }"
        @input="inputUpdate('isProcedureDateRelated', $event.value)"
      />
      <v-btn
        v-if="rolename == 'Admin'"
        outlined
        color="accent"
        large
        rounded
        @click="showChoosePracticeDialog = true"
        >Share with a Company</v-btn
      >
      <v-btn
        outlined
        color="accent"
        large
        rounded
        @click="showConfirmDeleteDialog = true"
        >Delete</v-btn
      >
      <v-btn
        outlined
        color="accent"
        large
        rounded
        @click="duplicateTemplatePopup = true"
        >Duplicate</v-btn
      >
    </div>
    <v-dialog
      v-model="showConfirmDeleteDialog"
      persistent
      max-width="500"
      @click:outside="onClickOutside"
      @keydown="onKeydown"
    >
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this item? 🥵</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="rounded-pill" text @click="closeConfirmDeleteDialog"
            >No</v-btn
          >
          <v-btn
            class="rounded-pill elevation-0"
            color="accent"
            @click="openDeleteDialog"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteTemplatePopup"
      persistent
      max-width="450"
      @click:outside="onClickOutside"
      @keydown="onKeydown"
    >
      <v-card>
        <v-card-title class="headline"
          >Are you really sure you want to delete this for
          EVERYONE?</v-card-title
        >
        <v-card-actions class="v-card__actions--flexcenter">
          <v-btn class="rounded-pill" text @click="closeDeleteDialog"
            >Cancel</v-btn
          >
          <v-btn
            class="rounded-pill elevation-0"
            color="accent"
            @click="submitDelete"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="duplicateTemplatePopup"
      persistent
      max-width="290"
      @click:outside="onClickOutside"
      @keydown="onKeydown"
    >
      <v-card>
        <v-card-title class="headline">Duplicate this sprint?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="rounded-pill" text @click="closeDuplicateDialog"
            >Cancel</v-btn
          >
          <v-btn
            class="rounded-pill elevation-0"
            color="accent"
            @click="submitDuplicate"
            >Duplicate</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <choose-practice-dialog
      :key="choosePracticeDialogKey"
      :show-dialog="showChoosePracticeDialog"
      @close-dialog="closeChoosePracticeDialog"
      @on-submit="choosePractice"
    />
  </div>
</template>

<script>
import BhTextInput from '@/components/inputs/BhTextInput.vue'
import DialogCheckbox from '@/components/forms/DialogCheckbox.vue'
import ChoosePracticeDialog from '@/components/dialogs/ChoosePracticeDialog.vue'
import { mapState } from 'vuex'
export default {
  name: 'TemplateCard',
  components: {
    BhTextInput,
    DialogCheckbox,
    ChoosePracticeDialog,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      choosePracticeDialogKey: 1,
      deleteTemplatePopup: false,
      duplicateTemplatePopup: false,
      showChoosePracticeDialog: false,
      showConfirmDeleteDialog: false,
    }
  },
  computed: {
    ...mapState('userStates', ['rolename']),
  },
  methods: {
    inputUpdate(input, val) {
      this.$emit('input-update', input, val)
    },
    closeChoosePracticeDialog() {
      this.showChoosePracticeDialog = false
      this.choosePracticeDialogKey++
    },
    choosePractice(practices) {
      this.$emit('practices-update', practices)
    },
    openDeleteDialog() {
      this.closeConfirmDeleteDialog()
      this.deleteTemplatePopup = true
    },
    closeDeleteDialog() {
      this.deleteTemplatePopup = false
    },
    closeDuplicateDialog() {
      this.duplicateTemplatePopup = false
    },
    submitDelete() {
      this.$emit('delete', this.user.id)
    },
    submitDuplicate() {
      this.$emit('duplicate', this.user.id)
    },
    closeConfirmDeleteDialog() {
      this.showConfirmDeleteDialog = false
    },
    onClickOutside() {
      this.closeDeleteDialog()
      this.closeDuplicateDialog()
      this.closeConfirmDeleteDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) {
        this.closeDeleteDialog()
        this.closeDuplicateDialog()
        this.closeConfirmDeleteDialog()
      }
    },
    openConfirmDeleteDialog() {
      this.showConfirmDeleteDialog = true
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables';

.template-card {
  display: flex;
  flex-direction: column;
  .v-input .v-label {
    font-size: 1rem;
  }
  .v-btn {
    margin-top: 30px;
    border-width: 2px;
  }
}
</style>
